import { render } from "./MainTrivias.vue?vue&type=template&id=9f71e9d0"
import script from "./MainTrivias.vue?vue&type=script&lang=js"
export * from "./MainTrivias.vue?vue&type=script&lang=js"

import "./MainTrivias.vue?vue&type=style&index=0&id=9f71e9d0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/trivias/MainTrivias.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f71e9d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f71e9d0', __exports__)) {
    api.reload('9f71e9d0', __exports__)
  }
  
  module.hot.accept("./MainTrivias.vue?vue&type=template&id=9f71e9d0", () => {
    api.rerender('9f71e9d0', render)
  })

}


export default __exports__